import { render, staticRenderFns } from "./SubmitFeedbackDialog.vue?vue&type=template&id=7f0f4179&scoped=true&"
import script from "./SubmitFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitFeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f4179",
  null
  
)

export default component.exports